<template>
  <div class="image-item" :class="imageClasses">
    <div class="image-thumb">
      <img 
        v-b-tooltip.hover :title="imageAltText"
        :src="`${apiUrl}viewFileSocialMediaPost/${image.social_post_id}/${image.id}/${token}`" 
        @click="thumbnailClicked" 
        @mousedown="thumbnailMouseDown"
        @mouseup="thumbnailMouseUp" />
        <i v-b-tooltip.hover  title="Missing Alt Text"
         v-if="image.alt_text == null || image.alt_text == ''" class="fas fa-exclamation-circle missing-alt-text-icon"></i>
    </div>
    <!--
    <div class="image-description">
      <span>{{ image.file_name }}</span>
    </div>
    -->
    
    <a v-if="!disabled" href="#" class="image-delete" :data-img-id="image.id" @click="deleteImageClicked">
      <i class="fas fa-trash"></i>
    </a>
    

    <b-modal 
      id="image-thumbnail-popup-modal"
      v-model="showImagePopup" 
      size="lg"
    >
      <img :src="`${apiUrl}viewFileSocialMediaPost/${image.social_post_id}/${image.id}/${token}`" class="post-image-popup" />
      <template #modal-footer="{ ok, cancel, hide }">
        <div class="image-alt">
          <label :for="'image-alt-'+image.id">Image Alt Text</label>
          <input :name="'image-alt-'+image.id" type="text" placeholder="Enter image alt text" class="image-alt-input" :class="imageClasses" :disabled="altDisabled" v-model="alt" @blur="imageAltTextUpdated" @keyup.enter.stop="imageAltTextUpdated" ref="altTextInput" />
          <button title="Delete Image" class="btn delete-deliverable-btn" @click="deleteImageClicked"><i class="fas fa-trash-alt"></i></button>
        </div>
      </template>
    </b-modal>
    <b-modal v-model="showRemoveImage" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveImage" ok-title="Yes, Delete">
      <p>Are you sure you want to delete this image?</p>
    </b-modal>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {ref} from 'vue';

export default {
  data() {
    return {
      src: "",
      showImagePopup: false,
      mouseDown: false,
      dragged: false,
      alt: "",
      altDisabled: false,
      showRemoveImage: false,
    }
  },
  components: {
    
  },
  props: ['image', 'dragging', 'disabled', 'namespace'],
  computed: {
		...mapState({
			state (state) {
			return state[this.namespace]
			},
			deliverableDetail (state, getters) {
			return getters[this.namespace + 'deliverableDetail']
			},
			systemSettings (state, getters) {
			return getters['systemSettings']
			},
		}),
    token(){
      return this.$store.getters.authToken;
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    imageClasses() {
      let ob = {};
      if(this.alt == ""){
        ob['no-alt'] = true;
      }
      if(this.disabled){
        ob['disabled'] = true;
      }
      return ob;
    },
    imageAltText() {
      if(this.alt == ""){
        return "Click to set alt text"
      }
      return this.alt;
    }
  },
  methods: {
    deleteImageClicked(e){
      e.preventDefault();
      this.showRemoveImage = true;
    },
    onConfirmRemoveImage(){
      this.$store.dispatch(this.namespace + "removeFileSocialMediaPost", {
        id: this.image.social_post_id,
        file_id: [this.image.id]
      });
      this.showImagePopup = false;
    },
    thumbnailClicked(e){
      if(!this.dragged && !this.disabled){
        this.initAltText();
        this.showImagePopup = true;
        let that = this;
        let altCheck = setInterval(function(){
          let altText = that.$refs.altTextInput;
          if(altText){
            altText.focus();
            clearInterval(altCheck);
          }
        }, 100);

      }
    },
    thumbnailMouseDown(e){
      this.mouseDown=true;
      this.dragged = false;
    },
    thumbnailMouseUp(e){
      this.mouseDown=false;
    },
    imageAltTextUpdated(){
      if(this.alt === this.image.alt_text){
        return;
      }
      this.altDisabled = true;
      let that = this;
      this.$store.dispatch(this.namespace + "updateFileAltTextSocialMediaPost",
      {
        id: this.image.social_post_id,
        file_id: [this.image.id],
        value: this.alt
      }).then(function(){
        that.altDisabled = false;
        that.showImagePopup = false;
      });
    },
    initAltText(){
      if(this.image.alt_text === null){
        this.image.alt_text = "";
      }
      this.alt = this.image.alt_text;
    }
  },
  watch: {
    dragging(){
      this.dragged = true;
    }
  },
  
  created(){
    this.initAltText();
  },

}
</script>